import Help from './Help';

export default Help;



// WEBPACK FOOTER //
// ./src/components/Help/index.js